export class ApiError extends Error {
    constructor(
        public readonly status: number,
        public readonly data: { message: string },
    ) {
        super(data.message);
        this.name = "ApiError";
    }
}
